module.exports = __webpack_public_path__ + "img/verify-phone.91ff123d.png";